import { Nature, Section } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import RegiePanel from '../panel/RegiePanel';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';

class ProfilEcritureRegieRecette extends BaseProfilEcritureRecette {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.REGIE;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.REGIE;
    this.typePiece = TYPE_PIECE.RECETTE.EMIS_APRES_PAIE;
    this.imputation.section = Section.FONCTIONNEMENT;
    this.imputation.nature = Nature.REEL;
    this.panels = [
      ...this.panels,
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new PeriodeCouvertePanel(),
      new ProjetPanel(),
      new RegiePanel(true),
    ];
  }
}

export default ProfilEcritureRegieRecette;
